import React from 'react';
import { useDispatch } from 'react-redux';
import { Col, Row } from 'reactstrap';
import TimeFilter from '../../../../organisms/timeFilter';

const Sorting = () => {
  const {
    interactiveTime: { setDatesInteractiveTime },
  } = useDispatch();

  const handleSubmit = (newDates) => {
    setDatesInteractiveTime({ newDates });
  };

  return (
    <Row>
      <Col xl="2" xs="12" md="6">
        <p className="mb-1">Report Time Window</p>
        <TimeFilter handleSubmit={handleSubmit} />
      </Col>
    </Row>
  );
};

export default Sorting;
